<div class="pt-5">
    <div class="table-controls-container" *ngIf="dataListLength; let count">
        <div class="header-container flex flex-row justify-between items-center">
            <div class="flex flex-col">
                <div class="text-title-2">Compounds</div>
                <div class="sub-header">
                There {{count !== 1 ? 'are' : 'is'}}
                <div class="bold">{{count}}</div> compound{{count !== 1 ? 's' : ''}}
                </div>
            </div>
            <div class="flex space-x-4">
                <app-button
                    text="Create Compound"
                    subStyle="white-primary-text-border"
                    customClasses="pl-4 pr-4"
                    (clicked)="createCompoundDialog$.next(true)">
                </app-button>
                <app-button
                    text="Receive Compound"
                    customClasses="pl-4 pr-4"
                    (clicked)="receiveCompoundDialog$.next(true)">
                </app-button>
            </div>
        </div>

        <div class="table-controls search-control">
            <app-search-input
                [color]="SearchInputColorEnum.Green"
                [hideDropdown]="true"
                placeholder="Search by name or ndc"
                [loading]="loading$ | async"
                (searchValueChanged)="searchValueChanged($event)"
            ></app-search-input>
        </div>
    </div>

    <app-button *ngIf="!dataListLength && !(loading$ | async)"
        class="!flex justify-end pr-8"
        text="Create Compound"
        subStyle="white-primary-text-border"
        customClasses="pl-4 pr-4"
        (clicked)="createCompoundDialog$.next(true)">
    </app-button>

    <app-generic-table *ngIf="dataListLength"
        [data]="filtered$ | async" 
        [columns]="columns"
        [withDetailsOption]="false"
        [template]="details"
        (goToDetail)="openDetail($event)"
    ></app-generic-table>

    <ng-template #details let-item let-i="index">
        <div class="text-right controls" *ngIf="item?.activityType === ActivityTypesEnum.Compounded">
            <button (click)="$event.stopPropagation(); openDetail(item?.id)"
                    [disabled]="loading"
                    class="details-btn animation-focus-default"
            >
              Details
            </button>
        </div>
    </ng-template>
    
</div>



<app-empty-table *ngIf="!(loading$ | async) && !dataListLength"
  [labelValue]="'You do not have any compounds yet'"
></app-empty-table>

<app-create-compound-dialog *ngIf="createCompoundDialog$ | async"
    (save)="createCompoundSubmitted($event)"
    (cancel)="createCompoundDialog$.next(false)">
</app-create-compound-dialog>

<app-receive-compound-dialog *ngIf="receiveCompoundDialog$ | async"
    (save)="receiveCompoundDialogSubmitted($event)"
    (cancel)="receiveCompoundDialog$.next(false)"
></app-receive-compound-dialog>